import React, { Fragment, useEffect, useState } from "react";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { ProgressSpinner } from "primereact/progressspinner";

import { EditBuyerInfo } from "./EditBuyerInfo";
import {
  convertInvoice,
  downloadInvoicePdf,
  downloadInvoiceXML,
} from "../../service/InvoiceService";
import { download } from "../../utils/download";

export const HoaDon = React.memo(
  ({ invInfo, display, setDisplay, onReload, token }) => {
    const [name, setName] = useState("");
    const [displayConvertDialog, setDisplayConvertDialog] = useState(false);
    const [displayEditBuyerInfoModal, setDisplayEditBuyerInfoModal] =
      useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState("");
    const [version, setVersion] = useState(0);
    const [pdfUrl, setPdfUrl] = useState("");

    useEffect(() => {
      setVersion(Date.now);
      setPdfLoading(true);

      return () => {
        setVersion(0);
      };
    }, [invInfo]);

    useEffect(() => {
      if (!invInfo.invoiceId) {
        return;
      }

      setPdfUrl("");
      downloadInvoicePdf(invInfo.invoiceId).then((blob) => {
        setPdfUrl(URL.createObjectURL(blob));
      });
    }, [invInfo]);

    const downloadPdf = () => {
      setDownloadLoading("pdf");
      downloadInvoicePdf(invInfo.invoiceId).then((blob) => {
        const url = URL.createObjectURL(blob);

        download(
          document,
          url,
          `${invInfo.thirdPartyCode}_${invInfo.invoiceNo}.pdf`,
        );
        setDownloadLoading("");
      });
    };

    const downloadXml = () => {
      setDownloadLoading("xml");
      downloadInvoiceXML(invInfo.invoiceId).then((blob) => {
        const url = URL.createObjectURL(blob);

        download(
          document,
          url,
          `${invInfo.thirdPartyCode}_${invInfo.invoiceNo}.xml`,
        );
        setDownloadLoading("");
      });
    };

    const showConvertDialog = () => {
      setDisplayConvertDialog(true);
    };

    const downloadConvertedInvoice = (event) => {
      event.preventDefault();

      if (name && name.trim()) {
        setDownloadLoading("convert");
        convertInvoice(invInfo.invoiceId, name).then((blob) => {
          const url = URL.createObjectURL(blob);

          download(
            document,
            url,
            `${invInfo.thirdPartyCode}_${invInfo.invoiceNo}_${name}.pdf`,
          );
          setDownloadLoading("");
          setDisplayConvertDialog(false);
        });
      }
    };

    return (
      <Fragment>
        {displayEditBuyerInfoModal && token && (
          <EditBuyerInfo
            token={token}
            onReload={onReload}
            invInfo={invInfo}
            display={displayEditBuyerInfoModal}
            setDisplay={setDisplayEditBuyerInfoModal}
          />
        )}

        <Dialog
          header="Chuyển đổi hóa đơn"
          visible={displayConvertDialog}
          style={{ width: "400px" }}
          onHide={() => setDisplayConvertDialog(false)}
        >
          <form onSubmit={downloadConvertedInvoice}>
            <div className="grid mt-2">
              <div className="col-12">
                <div className="field p-fluid">
                  <label htmlFor="name">Họ và tên người chuyển đổi</label>
                  <InputText
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="col-12 text-right">
                <Button
                  loading={downloadLoading === "convert"}
                  label="Tải xuống"
                  icon="pi pi-check"
                  type="submit"
                  className="p-button-sm mr-2"
                />
                <Button
                  label="Đóng"
                  icon="pi pi-times"
                  type="button"
                  onClick={() => setDisplayConvertDialog(false)}
                  className="p-button-sm p-button-secondary"
                />
              </div>
            </div>
          </form>
        </Dialog>

        <Dialog
          header="Thông tin hóa đơn"
          visible={!!display}
          style={{ width: "100vw", maxWidth: "1200px", height: "90%" }}
          position="top"
          onHide={() => setDisplay(0)}
        >
          <div className="grid" style={{ height: "100%" }}>
            <div className="col-fixed relative" style={{ width: "75%" }}>
              {pdfLoading && (
                <ProgressSpinner strokeWidth="4" className="progress-spinner" />
              )}
              {invInfo.invoiceId && pdfUrl && (
                <iframe
                  key={version}
                  onLoad={() => setPdfLoading(false)}
                  loading="lazy"
                  src={pdfUrl}
                  width="100%"
                  height="100%"
                  title={invInfo.invoiceId}
                />
              )}
            </div>
            <div className="col">
              <div className="surface-section">
                <div className="font-medium text-lg mb-3">
                  Thông tin hóa đơn
                </div>
                <div className="grid border-bottom-1 surface-border text-sm mt-1">
                  <div className="col-fixed" style={{ width: "160px" }}>
                    Mã tra cứu:
                  </div>
                  <div
                    className="col text-right"
                    style={{ fontWeight: "bold" }}
                  >
                    {invInfo["thirdPartyCode"]}
                  </div>
                </div>
                <div className="grid border-bottom-1 surface-border text-sm mt-1">
                  <div className="col-fixed" style={{ width: "160px" }}>
                    Số hóa đơn:
                  </div>
                  <div
                    className="col text-right"
                    style={{ fontWeight: "bold" }}
                  >
                    {invInfo["invoiceNo"]}
                  </div>
                </div>
                <div className="grid border-bottom-1 surface-border text-sm mt-1">
                  <div className="col-fixed" style={{ width: "160px" }}>
                    Tổng tiền thanh toán:
                  </div>
                  <div
                    className="col text-right"
                    style={{ fontWeight: "bold" }}
                  >
                    {invInfo["invoiceTotalLocaleString"]}
                  </div>
                </div>
              </div>
              <div className="grid p-fluid mt-5">
                <div className="col-12 pb-0">
                  <Button
                    loading={downloadLoading === "pdf"}
                    label="Tải hóa đơn PDF"
                    icon="pi pi-file-pdf"
                    className="p-button-outlined p-button-sm"
                    onClick={downloadPdf}
                  />
                </div>
                {invInfo.issueStatusId === "InvNotIssued" && (
                  <div className="col-12 pb-0">
                    <Button
                      label="Chỉnh sửa thông tin người mua"
                      icon="pi pi-pencil"
                      className="p-button-outlined p-button-sm p-button-secondary"
                      onClick={() => setDisplayEditBuyerInfoModal(true)}
                    />
                  </div>
                )}
                {invInfo.issueStatusId !== "InvNotIssued" && (
                  <div className="col-12 pb-0">
                    <Button
                      loading={downloadLoading === "xml"}
                      label="Tải hóa đơn XML"
                      icon="pi pi-download"
                      className="p-button-outlined p-button-sm p-button-secondary"
                      onClick={downloadXml}
                    />
                  </div>
                )}
                {invInfo.issueStatusId !== "InvNotIssued" && (
                  <div className="col-12 pb-0">
                    <Button
                      label="Chuyển đổi hóa đơn"
                      icon="pi pi-copy"
                      className="p-button-outlined p-button-sm p-button-success"
                      onClick={showConvertDialog}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Dialog>
      </Fragment>
    );
  },
);
